export default __webpack_public_path__ + "static/december-83cfe29f13ea794db9657e118319ee42.svg";